import { useEffect, useState } from 'react';
import { Wallet } from 'lucide-react';
import { getMyPayments, MyPayment, money, TYPE_LABEL, METHOD_LABEL } from '../api';
import { Skeleton } from '../../../components/Skeleton';
import EmptyState from '../../../components/EmptyState';

function fmtDate(d: string | null) {
  if (!d) return '—';
  return new Date(d.slice(0, 10) + 'T12:00:00').toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' });
}

export default function StudentPayments() {
  const [data, setData] = useState<{ data: MyPayment[]; total: number; count: number } | null>(null);
  useEffect(() => { getMyPayments().then(setData).catch(() => setData({ data: [], total: 0, count: 0 })); }, []);

  if (!data) return <div className="space-y-3"><Skeleton className="h-20 rounded-2xl" />{[0, 1, 2].map((i) => <Skeleton key={i} className="h-14 rounded-xl" />)}</div>;

  return (
    <div className="space-y-4">
      <h1 className="font-display text-xl font-bold text-content">Mis pagos</h1>
      <div className="rounded-2xl border border-line bg-surface p-5 shadow-sm">
        <div className="text-xs font-medium uppercase tracking-wide text-content-3">Total histórico</div>
        <div className="mt-1 font-display text-2xl font-bold text-content">{money(data.total)}</div>
        <div className="mt-1 text-xs text-content-3">{data.count} pagos registrados</div>
      </div>

      {data.data.length === 0 ? (
        <EmptyState icon={Wallet} title="Sin pagos registrados" subtitle="Aquí verás tu historial de pagos." />
      ) : (
        <div className="divide-y divide-line/60 overflow-hidden rounded-2xl border border-line bg-surface">
          {data.data.map((p) => (
            <div key={p.payment_id} className="flex items-center justify-between gap-3 px-4 py-3">
              <div className="min-w-0">
                <div className="truncate text-sm font-medium text-content">{p.assoc_name || TYPE_LABEL[p.type] || p.type}</div>
                <div className="text-xs text-content-3">{fmtDate(p.pay_date)} · {METHOD_LABEL[p.method] || p.method}{p.months ? ` · ${p.months}` : ''}</div>
              </div>
              <div className="shrink-0 font-medium text-content">{money(p.amount)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
